"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.enterKeyCode = exports.escapeKeyCode = void 0;
exports.escapeKeyCode = 27;
exports.enterKeyCode = 13;
//# sourceMappingURL=constants.js.map